import { AnfrageService } from '@/api/service-index';
import { AnfrageListDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/anfrage-list-display-model';
import { GlobalEnumsAceXfoundportalobjekt } from '@/api/model-index';
import { Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class GetAllProjektProjektideeAnfragenResolver implements Resolve<AnfrageListDisplayModel[]> {
  constructor(protected anfrageService: AnfrageService)
  {
    //
  }

  /**
   * Get all applications containing projects and projectideas.
   * 
   * @param route ActivatedRouteSnapshot
   * @param state RouterStateSnapshot
   * @returns Observable<BewerbungListDisplayModel>
   */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<AnfrageListDisplayModel[]> {
    return this.anfrageService.apiAnfrageGet({"x-anfragescope": [GlobalEnumsAceXfoundportalobjekt.Projekt, GlobalEnumsAceXfoundportalobjekt.Projektidee] })
      .pipe(
        map(response => {
          return response;
        })
      );    
  }
}
